import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export type TourId = 'sign' | 'verify' | 'admin-tv' | 'admin-rse';

export interface TourOpenOptions {
  /** Si true, abre aunque el usuario ya lo haya visto. */
  force?: boolean;
}

@Injectable({ providedIn: 'root' })
export class TourService {
  private readonly storagePrefix = 'certitool.tour.seen.';

  private openRequest$ = new Subject<{ tourId: TourId; force: boolean }>();
  private close$ = new Subject<void>();

  readonly onOpenRequest = this.openRequest$.asObservable();
  readonly onClose = this.close$.asObservable();

  openTour(tourId: TourId, options: TourOpenOptions = {}): void {
    const force = !!options.force;
    if (!force && this.hasSeen(tourId)) {
      return;
    }
    this.openRequest$.next({ tourId, force });
  }

  /** Abre el tour del contexto actual aunque ya se haya visto. */
  openTourForced(tourId: TourId): void {
    this.openTour(tourId, { force: true });
  }

  closeTour(): void {
    this.close$.next();
  }

  hasSeen(tourId: TourId): boolean {
    try {
      return localStorage.getItem(this.storagePrefix + tourId) === '1';
    } catch {
      return false;
    }
  }

  markSeen(tourId: TourId): void {
    try {
      localStorage.setItem(this.storagePrefix + tourId, '1');
    } catch {
      /* ignore quota / private mode */
    }
  }

  clearSeen(tourId?: TourId): void {
    try {
      if (tourId) {
        localStorage.removeItem(this.storagePrefix + tourId);
        return;
      }
      (['sign', 'verify', 'admin-tv', 'admin-rse'] as TourId[]).forEach((id) => {
        localStorage.removeItem(this.storagePrefix + id);
      });
    } catch {
      /* ignore */
    }
  }
}
